import { useContext } from 'react';
import {
  SnackbarContext,
  SnackbarContextType,
} from 'src/providers/snackbar/context';

export const useSnackbar = (): SnackbarContextType =>
  useContext(SnackbarContext);
